<template>
  <div>
    <div class="bottom_content_top">
      <div class="about_heart">
        <a href="" target="view_window">关于我们</a>｜
        <a href="" target="view_window">广告服务</a>｜
        <a href="" target="view_window">信息服务</a>｜
        <a href="" target="view_window">设置首页</a>｜
        <a href="" target="view_window">加入收藏</a>｜
        <a href="" target="view_window">投稿信箱</a>｜
      </div>
    </div>
    <div class="bottom_content_bot">
      <div class="record_heart">
        <span class="phone_email">濮阳县融媒体中心主办 举报电话0393-3225999 举报邮箱pyxrmt@163.com</span>
        <span class="copyright"><span class="yu_bei" @click="yuBeiFun">备案号：豫ICP备2022016563号-1</span></span>
      </div>
      <div class="bt-jb">
        <a href="http://www.12377.cn/" target="_blank"><img src="./img/zyjb.jpg" alt="中央网信办(国家网信办)违法和不良信息举报中心" width="172"
            height="50"></a>
        <a href="https://piyao.henanjubao.com/" target="_blank"><img src="../../../assets/biyao.jpg" alt="河南省网络辟谣平台"
            width="172" height="50"></a>
        <a href="http://henanjubao.com" target="_blank"><img src="./img/hnsjb.jpg" alt="河南省互联网违法和不良信息举报中心" width="172"
            height="50"></a>
        <a href="https://www.pyxww.com/pyshlwjbzx/" target="_blank"><img src="./img/jbpt.jpg" alt="“濮阳市互联网违法和不良信息举报中心"
            width="155" height="50"></a>
        <a href="https://www.pyxww.com/pysbypt/" target="_blank"><img src="./img/pypt.jpg" alt="濮阳市网络辟谣平台" width="155"
            height="50"></a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    yuBeiFun() {
      window.open('https://beian.miit.gov.cn')
    }
  }
}
</script>
<style lang="">
.yu_bei{
    cursor: pointer;
}
.yu_bei:hover{
    color: #0091ff;
}
    .bottom_content_top{
        width:100%;
        height:60px;
        background:rgba(55,78,122,1);
    }
    .bottom_content_bot{
        width: 100%;
        /* height:50px; */
        padding: 0 0 10px 0;
        text-align: center;
        background:rgba(44,61,97,1);
    }
    .bottom_content_bot .bt-jb img{
        margin: 0 10px;
    }
    .bottom_content_top .about_heart{
        width:1200px;
        margin:0 auto;
        height:60px;
        line-height:60px;
        text-align: center;
        color:rgba(221,221,221,1)
    }
    .bottom_content_top .about_heart a{
        font-size: 14px;
        font-weight: bolder;
        height:17px;
        line-height:17px;
        color:rgba(221,221,221,1)
    }
    .bottom_content_bot .record_heart{
        width:1200px;
        line-height: 50px;
        height:50px;
        margin:0 auto;
    }
    .bottom_content_bot .record_heart .phone_email{
        width:635px;
        height:16px;
        font-size:14px;
        font-weight:bold;
        color:rgba(221,221,221,1);
        line-height:17px;
        padding-left:83px;
    }
    .bottom_content_bot .record_heart .copyright{
        padding-left:114px;
        width:281px;
        height:14px;
        font-size:14px;
        font-weight:bold;
        color:rgba(221,221,221,1);
        line-height:17px;
    }
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/bottomContent.vue